import { PageHeader } from "../components/Common";
import { EntitiesTab } from "../components/settings/EntitiesTab";
import { LeaveRulesTab } from "../components/settings/LeaveRulesTab";
import { HolidaysTab } from "../components/settings/HolidaysTab";
import { LoginActivityTab } from "../components/settings/LoginActivityTab";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";

export default function SettingsPage() {
  return (
    <div data-testid="settings-page">
      <PageHeader eyebrow="Configuration" title="Settings" subtitle="Manage group companies, payroll formulas, leave rules, holidays and sign-in security." />
      <Tabs defaultValue="entities">
        <TabsList className="mb-6 flex-wrap h-auto">
          <TabsTrigger value="entities" data-testid="settings-tab-entities">Entities & payroll</TabsTrigger>
          <TabsTrigger value="leave" data-testid="settings-tab-leave-rules">Leave rules</TabsTrigger>
          <TabsTrigger value="holidays" data-testid="settings-tab-holidays">Holidays</TabsTrigger>
          <TabsTrigger value="security" data-testid="settings-tab-login-activity">Login activity</TabsTrigger>
        </TabsList>
        <TabsContent value="entities"><EntitiesTab /></TabsContent>
        <TabsContent value="leave"><LeaveRulesTab /></TabsContent>
        <TabsContent value="holidays"><HolidaysTab /></TabsContent>
        <TabsContent value="security"><LoginActivityTab /></TabsContent>
      </Tabs>
    </div>
  );
}
